import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../libs'
import { $params } from '../../../features/router'
import { DemoContestItem } from './types'

export const demoContestMounted = createEvent()

export const changeDemoContestStatusMounted = createEvent<{
  id: string
  status: string
}>()

export const getDemoContest = fx<void, DemoContestItem>({
  method: 'GET',
  url: '/contest/',
})

export const changeDemoContestStatus = fx<
  {
    status: string
  },
  void
>({
  method: 'PUT',
  url: `/contest`,
})

export const $demoContest = restore<DemoContestItem>(
  getDemoContest.doneData.map((a) => a.body),
  null,
)

sample({
  clock: demoContestMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.demoContestID
    }

    return {
      query: {
        populate: JSON.stringify(['Contest.updatedBy']),
      },
      url: `/contest/${id}`,
    }
  },
  target: getDemoContest,
})

sample({
  clock: changeDemoContestStatusMounted,
  fn: ({ id, status }) => {
    return {
      url: `/contest/${id}`,
      body: {
        status,
      },
    }
  },
  target: changeDemoContestStatus,
})

sample({
  clock: changeDemoContestStatus.done,
  fn: () => ({}),
  target: [demoContestMounted],
})
